export enum AtradiusCoverStatus {
    // Map to Referred
    Pending = 'Pending',

    // DC04|| DC06
    Partial = 'Partial',

    // DC05
    RefusalForIncrease = 'RefusalForIncrease',

    // DC01 || DC02
    Cover = 'Cover',

    // DC03 || DC07
    Rejected = 'Rejected',

    // DC10
    Revised = 'Revised',

    // DC11
    Reissue = 'Reissue',

    // DC22
    PartialExpiry = 'PartialExpiry',

    // DC08 || DC21
    WithdrawalOfLimit = 'WithdrawalOfLimit',

    // DC09
    ReductionOfCover = 'ReductionOfCover',
}
